import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiNextdotjs } from "react-icons/si";
import C from "../../Assets/TechIcons/C++.svg";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Python from "../../Assets/TechIcons/Python.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Firebase from "../../Assets/TechIcons/Firebase.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import Kubernates from "../../Assets/TechIcons/Kubernates.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import Postman from "../../Assets/TechIcons/Postman.svg";
import azure from "../../Assets/TechIcons/azure.svg";
import Kafka from "../../Assets/TechIcons/Kafka.svg";
import shellscripting from "../../Assets/TechIcons/shellscripting.svg";
import jenkins from "../../Assets/TechIcons/jenkins.svg";
import supabase from "../../Assets/TechIcons/supabase.svg";
import terraform from "../../Assets/TechIcons/terraform.svg";
import argocd from "../../Assets/TechIcons/argocd.svg";
import nextcloud from "../../Assets/TechIcons/nextcloud.svg";
import server from "../../Assets/TechIcons/server.svg";
import networking from "../../Assets/TechIcons/networking.svg";
import prometheus from "../../Assets/TechIcons/prometheus.svg";
import grafana from "../../Assets/TechIcons/grafana.svg";
import html from "../../Assets/TechIcons/html.svg";
import java from "../../Assets/TechIcons/java.svg";
import oracle from "../../Assets/TechIcons/oracle.svg";
import postgresql from "../../Assets/TechIcons/postgresql.svg";
import aws from "../../Assets/TechIcons/aws.svg";

const rowStyle = { justifyContent: "center", paddingBottom: "50px" };

const TECH_STACK = [
  { icon: java, alt: "java", label: "Java", iconClass: true },
  { icon: oracle, alt: "oracle", label: "Oracle", iconClass: true },
  { icon: postgresql, alt: "postgresql", label: "PostgreSQL", iconClass: true },
  { icon: C, alt: "C++", label: "C++", iconClass: false },
  { icon: html, alt: "html", label: "HTML", iconClass: true },
  {
    icon: shellscripting,
    alt: "shellscripting",
    label: "Shell Scripting",
    iconClass: true,
  },
  { icon: jenkins, alt: "jenkins", label: "Jenkins", iconClass: true },
  { icon: prometheus, alt: "prometheus", label: "Prometheus", iconClass: true },
  { icon: grafana, alt: "grafana", label: "Grafana", iconClass: true },
  { icon: argocd, alt: "argocd", label: "Argocd", iconClass: true },
  { icon: terraform, alt: "terraform", label: "Terraform", iconClass: true },
  { icon: supabase, alt: "supabase", label: "Supabase", iconClass: true },
  { icon: nextcloud, alt: "nextcloud", label: "Nextcloud", iconClass: true },
  { icon: server, alt: "server", label: "Server Management", iconClass: true },
  { icon: networking, alt: "networking", label: "Networking", iconClass: true },
  {
    icon: Javascript,
    alt: "javascript",
    label: "Javascript",
    iconClass: false,
  },
  { icon: ReactIcon, alt: "react", label: "React.Js", iconClass: false },
  { component: <SiNextdotjs fontSize={"24px"} />, label: "Next.js" },
  { icon: Git, alt: "git", label: "Git", iconClass: false },
  { icon: Firebase, alt: "firebase", label: "Firebase", iconClass: false },
  { icon: Docker, alt: "docker", label: "Docker", iconClass: false },
  {
    icon: Kubernates,
    alt: "kubernetes",
    label: "Kubernetes",
    iconClass: false,
  },
  { icon: Python, alt: "Python", label: "Python", iconClass: false },
  { icon: Tailwind, alt: "tailwind", label: "Tailwind CSS", iconClass: false },
  { icon: Postman, alt: "Postman", label: "Postman", iconClass: false },
  { icon: azure, alt: "azure", label: "Azure", iconClass: true },
  { icon: aws, alt: "aws", label: "AWS", iconClass: true },
  { icon: Kafka, alt: "Kafka", label: "Kafka", iconClass: true },
];

function Techstack() {
  return (
    <Row style={rowStyle}>
      {TECH_STACK.map(({ icon, alt, label, iconClass, component }) => (
        <Col xs={4} md={2} className="tech-icons" key={label}>
          {component ?? (
            <img
              src={icon}
              alt={alt}
              className={iconClass ? "tech-icon-images" : undefined}
            />
          )}
          <div className="tech-icons-text">{label}</div>
        </Col>
      ))}
    </Row>
  );
}

export default React.memo(Techstack);
